import styled from "styled-components";
import { spacing } from "../../../design-system/tokens/spacing";
import { typographyMixin } from "../../../design-system/tokens/typography";
import { rawColors } from "../../../design-system/tokens/colors";

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing[3]};
  min-width: 0;
  flex: 1 0 0;
`;

export const TitleBlock = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-bottom: 2px;
  min-width: 0;
`;

export const DisplayName = styled.h3`
  margin: 0;
  ${typographyMixin("subtitle", 2)}
  color: ${rawColors.text.highEmphasis};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ProviderLabel = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
